export default [
    {
        featureType: 'all',
        elementType: 'all',
        stylers: [
            {
                saturation: '32',
            },
            {
                lightness: '-3',
            },
            {
                visibility: 'on',
            },
            {
                weight: '1.18',
            },
        ],
    },
    {
        featureType: 'administrative',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'on',
            },
        ],
    },
    {
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'landscape.man_made',
        elementType: 'all',
        stylers: [
            {
                saturation: '-70',
            },
            {
                lightness: '14',
            },
            { color: "#F8F4F1" }
        ],
    },
    {
        featureType: 'landscape.natural',
        elementType: 'all',
        stylers: [
            { color: "#FAE6DB" }
        ],
    },
    {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
            { color: "#ffffff" }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
            { color: "#ffffff" }
        ]
    },
    {
        featureType: "road.highway.controlled_access",
        elementType: "geometry",
        stylers: [
            { "color": "#ffffff" }
        ]
    },
    {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
            { color: "#ffffff" }
        ]
    },
    {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            }
        ],
    },
    {
        featureType: 'water',
        elementType: 'all',
        stylers: [
            {
                saturation: '100',
            },
            {
                lightness: '-14',
            },
            {
                color: "#B3E6F4",
            }
        ],
    },
    {
        featureType: 'water',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
            {
                lightness: '12',
            },
        ],
    },
];